import { useEffect } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { usePlatformAuth } from "../context/platformAuth";

export function SystemLayout() {
  const { bootstrap, logout } = usePlatformAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const routePrefix = location.pathname.startsWith("/tg/system") ? "/tg/system" : "/sys";
  const loginRoute = routePrefix === "/tg/system" ? "/tg/system/login" : "/sys/login";

  useEffect(() => {
    if (routePrefix !== "/tg/system") return;
    const webApp = (window as unknown as { Telegram?: { WebApp?: { ready?: () => void; expand?: () => void } } }).Telegram?.WebApp;
    try {
      webApp?.ready?.();
      webApp?.expand?.();
    } catch {
      // Ignore browsers without Telegram bridge.
    }
  }, [routePrefix]);

  return (
    <div className="system-shell">
      <aside className="system-nav">
        <h1 className="text-xl font-semibold">System Manager</h1>
        <p className="text-xs text-slate-500 mt-1">Platform console</p>
        <div className="mt-5 grid gap-2">
          <NavLink to={`${routePrefix}/dashboard`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Diagnostics
          </NavLink>
          <NavLink to={`${routePrefix}/tenants`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Tenants
          </NavLink>
          <NavLink to={`${routePrefix}/abuse/dashboard`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Abuse Dashboard
          </NavLink>
          <NavLink to={`${routePrefix}/abuse/limits`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Rate Limits
          </NavLink>
          <NavLink to={`${routePrefix}/abuse/blocklist`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Blocklist
          </NavLink>
          <NavLink to={`${routePrefix}/presets/countries`} className={({ isActive }) => (isActive ? "nav-chip nav-chip-active" : "nav-chip")}>
            Country Presets
          </NavLink>
        </div>
        <div className="mt-5 text-xs text-slate-500">
          <div>Total: {bootstrap?.summary.tenants_total ?? 0}</div>
          <div>Active: {bootstrap?.summary.tenants_active ?? 0}</div>
          <div>Suspended: {bootstrap?.summary.tenants_suspended ?? 0}</div>
        </div>
        <button
          className="btn secondary mt-5 w-full"
          onClick={() => {
            logout();
            navigate(loginRoute, { replace: true });
          }}
        >
          Logout
        </button>
      </aside>
      <main className="system-main">
        <Outlet />
      </main>
    </div>
  );
}

